import "./WhatsAppFab.css";
import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppFab({
  phone = "971505330836",
  message = "Hello Telviora, I’m interested in your eSIM offer",
}) {
  const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

  return (
    <a
      className="wa-fab"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contact Telviora on WhatsApp"
    >
      <FaWhatsapp size={28} />
    </a>
  );
}
